import { Component, OnInit, AfterViewChecked, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { EventService } from '../../../services/event/event.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-video-link-upload-modal',
  templateUrl: './video-link-upload-modal.component.html',
  styleUrls: ['./video-link-upload-modal.component.css']
})
export class VideoLinkUploadModalComponent implements OnInit, AfterViewInit {

  @ViewChild('closeLinkUploadModal') public closeLinkUploadModal: ElementRef;
  @ViewChild('linkUploadModalBtn') public linkUploadModalBtn: ElementRef;

  public uniqueId = null;
  public data = {
    name: '',
    link: ''
  };

  constructor(
    private event: EventService
  ) { }

  ngOnInit() {
    this.event.on('video-link-upload-modal', 'showVideoLinkUploadModal', uniqueId => {
      this.uniqueId = uniqueId;
    });
  }

  ngAfterViewInit() {
    $('#videoLinkUploadModal').on('hidden.bs.modal', () => {
      this.data = {
        name: '',
        link: ''
      };
    });
  }

  show() {
    this.linkUploadModalBtn.nativeElement.click();
  }

  onLinkUpload() {
    if (!this.data.name || !this.data.link) {
      swal('Warning', 'Please fill all the fields', 'warning');
      return;
    }

    let validUrl = null;
    try {
      const url = new URL(this.data.link);
      console.log(url);
      validUrl = url.href;
    } catch (err) { validUrl = null; }
    if (!validUrl) {
      swal('Warning', 'Please enter a valid URL', 'warning');
      return;
    }
    this.event.emit('videoLinkUpload', {
      name: this.data.name,
      path: validUrl,
      enc_name: null,
      extension: null,
      uniqueId: this.uniqueId
    });
    this.closeLinkUploadModal.nativeElement.click();
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/video-upload/video-link-upload-modal/video-link-upload-modal.component.ts